export default class ContactSubTypes {
  static VENDOR = "vendor";

  static CUSTOMER = "customer";
}
